define('home/templates/unreadCount',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Show One New Item",{"name":"gettext","hash":{},"data":data}))
    + "\n";
},"3":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Show %(x)s New Items",{"name":"gettext","hash":{"x":(depth0 != null ? depth0.numUnread : depth0)},"data":data}))
    + "\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<button class=\"button button-padding-taller button-wide button-fill--brand text-medium\">\n"
    + ((stack1 = helpers["if"].call(alias1,helpers.eq.call(alias1,(depth0 != null ? depth0.numUnread : depth0),1,{"name":"eq","hash":{},"data":data}),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</button>\n";
},"useData":true})

});
